var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { CustomFieldsApi } from './apis/custom-fields-api.interface';
let CustomFieldsRepositoryImpl = class CustomFieldsRepositoryImpl {
    constructor(_customFieldsApi) {
        this._customFieldsApi = _customFieldsApi;
    }
    async queryFields(fetchCompanyCustomFieldsOrNot) {
        const request = {
            public_field: fetchCompanyCustomFieldsOrNot,
        };
        const response = await this._customFieldsApi.queryFields(request);
        const result = {
            currentSort: response.current_sort,
            fields: response.custom_field,
            counts: {
                customFieldCount: response.custom_field_count,
                publicCustomFieldCount: response.public_field_count,
            },
        };
        return result;
    }
};
CustomFieldsRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(CustomFieldsApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof CustomFieldsApi !== "undefined" && CustomFieldsApi) === "function" ? _a : Object])
], CustomFieldsRepositoryImpl);
export { CustomFieldsRepositoryImpl };
